module.exports = __webpack_public_path__ + "static/media/PATS_1-139w.3ebacb63.webp";